import React from 'react';
// Import images
import shape8 from '../assets/img/shape/shape-8.png';
import logoLight from '../assets/img/logo/logo-light.png';

const Footer = () => {
  return (
    <>
      <style jsx>{`
        /* Subscribe Now Button */
        .theme-btn {
          background-color: #098535 !important;
          border-color: #098535 !important;
          color: white !important;
          transition: all 0.3s ease;
        }
        
        .theme-btn:hover {
          background-color: #fede33 !important; /* Yellow on hover */
          border-color: #fede33 !important;
          color: #222 !important; /* Dark text on yellow background */
        }
        
        /* Menu hover colors */
        .footer-list li a:hover {
          color: #fede33 !important;
        }
        
        /* Caret icon color */
        .fas.fa-caret-right {
          color: #fede33 !important;
        }
        
        /* Social icons hover */
        .footer-social li a:hover {
          color: #fede33 !important;
        }
      `}</style>
      
      <div>
        <footer className="footer-area">
          <div className="footer-widget">
              <div className="container">
                  <div className="row footer-widget-wrapper pt-100 pb-70">
                      <div className="col-md-6 col-lg-4">
                          <div className="footer-widget-box about-us">
                              <a href="#" className="footer-logo">
                                  <img src={logoLight} alt="CabandGo Logo" />
                              </a>
                              <p className="mb-3">
                                  We are many variations of passages available but the majority have suffered alteration
                                  in some form by injected humour words believable.
                              </p>
                          </div>
                      </div>
                      <div className="col-md-6 col-lg-2">
                          <div className="footer-widget-box list">
                              <h4 className="footer-widget-title">Quick Links</h4>
                              <ul className="footer-list">
                                  <li><a href="#"><i className="fas fa-caret-right"></i> About Us</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Update News</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Testimonials</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Terms Of Service</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Privacy policy</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Our Drivers</a></li>
                              </ul>
                          </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                          <div className="footer-widget-box list">
                              <h4 className="footer-widget-title">Support Center</h4>
                              <ul className="footer-list">
                                  <li><a href="#"><i className="fas fa-caret-right"></i> FAQ's</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Affiliates</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Booking Tips</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Book A Ride</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Contact Us</a></li>
                                  <li><a href="#"><i className="fas fa-caret-right"></i> Sitemap</a></li>
                              </ul>
                          </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                          <div className="footer-widget-box list">
                              <h4 className="footer-widget-title">Newsletter</h4>
                              <div className="footer-newsletter">
                                  <p>Subscribe Our Newsletter To Get Latest Update And News</p>
                                  <div className="subscribe-form">
                                      <form action="#">
                                          <input type="email" className="form-control" placeholder="Your Email" />
                                          <button className="theme-btn" type="submit">
                                              Subscribe Now <i className="far fa-paper-plane"></i>
                                          </button>
                                      </form>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="copyright">
              <div className="container">
                  <div className="row">
                      <div className="col-md-6 align-self-center">
                          <p className="copyright-text">
                              &copy; Copyright <span id="date">{new Date().getFullYear()}</span> <a href="#"> CabandGo </a> All Rights Reserved.
                          </p>
                      </div>
                      <div className="col-md-6 align-self-center">
                          <ul className="footer-social">
                              <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                              <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                              <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                              <li><a href="#"><i className="fab fa-youtube"></i></a></li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>
        </footer>
      </div>
    </>
  )
}

export default Footer